import { render, staticRenderFns } from "./56.vue?vue&type=template&id=190511f0&scoped=true&"
import script from "./56.vue?vue&type=script&lang=js&"
export * from "./56.vue?vue&type=script&lang=js&"
import style0 from "./56.vue?vue&type=style&index=0&id=190511f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190511f0",
  null
  
)

export default component.exports